import React from "react";

const PercentageProgressBarWithHeading = ({ percent }) => {

  const progressBarStyle = {
    width: `${percent > 100 ? 100 : percent}%`,
    height: "26px",
    backgroundColor: "#36b04b",
    transition: "width 0.3s ease-in-out",
    borderRadius: "3px"
  };

  return (
    <div
      className="progress-bar"
      style={{
        width: "100%",
        height: "26px",
        backgroundColor: "#d3dce6",
        borderRadius: "3px",
      }}
    >
      <div className="progress-bar-inner text-right" role="progressbar" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100"
        aria-label="Percentage Progress Bar"
        aria-valuetext={`${percent}% Complete`}
        aria-labelledby="percentage-progress-bar"
        aria-describedby="percentage-progress-bar-description"
        aria-hidden="true"
        aria-atomic="true"
        aria-live="assertive"
        aria-relevant="additions text" style={progressBarStyle}>
        <small className="fw-bold fs-18 text-light mx-2">{`${Math.floor(percent)}%`}</small>
      </div>
    </div>
  );
};

export default PercentageProgressBarWithHeading;
